import * as Reflux from "reflux";

export default Reflux.createActions(["loadCookieLaw", "acceptCookieLaw"]);
